/* GANS · Direction C motion: reveal on scroll, scroll-driven tilt, hero parallax. No libraries. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var reveal = function () {
    var els = document.querySelectorAll('.g-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  };
  var tilts = [], paras = [], ticking = false;
  var collect = function () {
    tilts = Array.prototype.slice.call(document.querySelectorAll('.g-tilt'));
    paras = Array.prototype.slice.call(document.querySelectorAll('.g-parallax'));
  };
  var update = function () {
    ticking = false;
    var vh = window.innerHeight || 800;
    tilts.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var c = (r.top + r.height / 2) / vh;
      el.style.setProperty('--g-tilt', ((0.5 - c) * 10).toFixed(2) + 'deg');
    });
    paras.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var c = (r.top + r.height / 2) / vh;
      el.style.setProperty('--g-py', ((c - 0.5) * -28).toFixed(1) + 'px');
    });
  };
  var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } };
  var init = function () { reveal(); collect(); update(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', init);
})();
